import {BaseModel} from '../../_base/crud';

export class Region extends BaseModel {
    id: number;
    name: string ;
    code: string;
    wilayaSet: string [];
    userId: number;
 }
